const design = {
    uiBlack: {
        50: '#F2F2F2',
        100: '#E5E5E5',
        200: '#CCCCCC',
        300: '#B3B3B3',
        400: '#999999',
        500: '#808080',
        600: '#666666',
        700: '#4D4D4D',
        800: '#333333',
        900: '#1A1A1A',
        1000: '#000000',
    },
    modalOverlay: '#00000066',

    lightBeige: {
        50: '#FFFEFE',
        100: '#FEFEFD',
        200: '#FEFDFB',
        300: '#FDFCFA',
        400: '#FCFBF8',
        500: '#FBF9F6',
        600: '#FBF8F4',
        700: '#FAF7F2',
        800: '#F9F6F1',
        900: '#F9F5EF',
        1000: '#F8F4ED',
    },

    //  Colors used in PDP after revamp
    // https://www.figma.com/file/QmLtYvJl3augvSHHpEjruZ/PDP---Design-sprint?type=design&node-id=2072-7742&mode=design&t=SbnfFNRPQtrsahuW-0
    white: '#FFFFFF',

    pepper: {
        50: '#F5F5F6',
        100: '#ECECEC',
        200: '#D9D9D9',
        300: '#C6C6C6',
        400: '#B3B3B3',
        500: '#A09FA0',
        600: '#8D8C8E',
        700: '#7A797B',
        800: '#676668',
        900: '#545355',
        1000: '#414042',
    },

    saleErrorRed: {
        50: '#FCF4F5',
        100: '#F9E8EB',
        200: '#F4D1D7',
        300: '#EEBBC3',
        400: '#E8A4AF',
        500: '#E38D9B',
        600: '#DD7686',
        700: '#D75F72',
        800: '#D1495E',
        900: '#CC324A',
        1000: '#C61B36',
    },

    primaryGreen: {
        50: '#F5F7F6',
        100: '#EBEFED',
        200: '#D7E0DB',
        300: '#C3D0CA',
        400: '#AFC1B8',
        500: '#9BB1A6',
        600: '#88A194',
        700: '#749282',
        800: '#608271',
        900: '#4C735F',
        1000: '#38634D',
    },

    successGreen: {
        50: '#F3F8F4',
        100: '#E8F2E9',
        200: '#D1E5D3',
        300: '#B9D8BC',
        400: '#A2CBA6',
        500: '#8BBD90',
        600: '#74B07A',
        700: '#5DA364',
        800: '#45964D',
        900: '#2E8937',
        1000: '#177C21',
    },

    grey: {
        50: '#FCFCFC',
        100: '#F9F9F9',
        150: '#F6F5F6',
        200: '#F3F2F2',
        250: '#F0EFEF',
        300: '#EDECEC',
        400: '#E7E5E6',
        500: '#E1DFDF',
        600: '#DCD9D9',
        700: '#D6D2D3',
        800: '#D0CCCD',
        900: '#CAC5C6',
        1000: '#C4BFC0',
    },
};

export const colors = {
    transparent: 'transparent',
    current: 'currentColor',
    black: design.uiBlack[1000],
    white: design.white,
    'slt-black': design.uiBlack,
    'slt-black-overlay': design.modalOverlay,
    'slt-pepper': design.pepper,
    'slt-red': design.saleErrorRed,
    'slt-red-error': design.saleErrorRed[1000],
    'slt-success-green': design.successGreen,
    'slt-primary-green': design.primaryGreen,
    'slt-beige': design.lightBeige,
    'slt-grey': design.grey,
    'slt-grey-light': design.grey[150],
};
